module.exports = __webpack_public_path__ + "static/IMG-20181030-WA0010-1024x576-050e5a797158d4fef33707276d3ec622.jpg";